import React from 'react';
import PropTypes from 'prop-types';

import { MILogo } from './../Icons';
import Button from './../Button';
import { CDN_URL } from '../../constants';

const HeroLarge = ({ description, donate, image, subtitle, title, ...rest }) => {
  return (
    <div className='hero-large' {...rest}>
      {image && (
        <div className='hero-large__image' style={{ backgroundImage: `url(${CDN_URL}${image})` }} />
      )}
      <div className='container'>
        <div className='row'>
          <div className='col'>
            <div className='hero-large__container'>
              <div className='hero-large__secondary'>
                <div className='hero-large__branding'>
                  <MILogo className={'hero-large__logo'} />
                </div>
                {title && <div className='hero-large__title'>{title}</div>}
              </div>
              <div className='hero-large__main'>
                {(subtitle || description) && (
                  <div className='hero-large__copy'>
                    {subtitle && <div className='hero-large__subtitle'>{subtitle}</div>}
                    {description && <div className='hero-large__description'>{description}</div>}
                  </div>
                )}
                {donate && (
                  <div className='hero-large__cta'>
                    <Button
                      href={donate}
                      className='hero-large__cta-link'
                      rel='noreferrer'
                      target='_blank'
                      theme='orange'
                    >
                      Donate
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

HeroLarge.propTypes = {
  description: PropTypes.string,
  donate: PropTypes.string,
  image: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string,
};

export default HeroLarge;
